var map = {
	"./en": 163,
	"./en.js": 163,
	"./fr": 164,
	"./fr.js": 164
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 508;



//////////////////
// WEBPACK FOOTER
// ./src/data/messages ^\.\/.*$
// module id = 508
// module chunks = 149121111297344 173463008800483